import {FlowStatePresentation} from "@nolimit/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimit/slot-game/bin/flowcontrol/FlowStateController";
import {FireInTheHole2} from "../FireInTheHole2";
import {gsap} from "gsap";

export class FITH2IdleNormalPresentation implements FlowStatePresentation {
    constructor() {
    }

    private skip(flowStateController: FlowStateController): void {
        flowStateController.finish();
    }

    public start(flowStateController: FlowStateController) {
        const tl = gsap.timeline();
        FireInTheHole2.xBetController.buttonsVisible = true;
        tl.add(gsap.to(this, {duration: 0.1}));
        tl.add(() => {
            if (!FireInTheHole2.autoPlayPlugin.isAutoplayRound) {
                FireInTheHole2.xBetController.featureEnabled = true;
                FireInTheHole2.xBetController.startIdle(!FireInTheHole2.model.gameData);
                FireInTheHole2.logo.startIdle();
            }
            flowStateController.finish();
        });
    }
}